import React, { useState } from "react";
import { Form, Button, InputGroup } from "react-bootstrap";

/** Campo de contraseña con botón de mostrar/ocultar (ícono de ojo). */
export default function CampoPassword({ label, value, onChange, autoComplete }) {
  const [mostrar, setMostrar] = useState(false);
  return (
    <Form.Group className="mb-3">
      <Form.Label>{label}</Form.Label>
      <InputGroup>
        <Form.Control
          type={mostrar ? "text" : "password"}
          value={value}
          onChange={onChange}
          required
          minLength={8}
          autoComplete={autoComplete}
        />
        <Button variant="outline-secondary" type="button" tabIndex={-1} onClick={() => setMostrar((m) => !m)}>
          <i className={`bi ${mostrar ? "bi-eye-slash" : "bi-eye"}`}></i>
        </Button>
      </InputGroup>
    </Form.Group>
  );
}
